(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["announcement"] && !Shopify.designMode) return;
  try {
    // Sparkle bloom, ported from the Claude Code ASCII spinner: an ornament
  // morphs through the glyph ramp on a triangle-wave sequence (ends held a
  // beat longer), with scale + opacity tracking the bloom level.
  const OK_ANN_ORNAMENTS = ['₊', '⟡', '⊹', '✦', '✧', '✵', '❋'];
  const OK_ANN_GLYPHS = ['·', '+', '✧', '✦', '✵', '❋'];
  const OK_ANN_SEQUENCE = [0, 0, 1, 2, 3, 4, 5, 5, 4, 3, 2, 1];
  // Per-slide "Twinkle speed" setting → [base ms/step, random spread].
  const OK_ANN_SPEED = { calm: [200, 90], medium: [150, 80], lively: [110, 60] };
  // Read a 0–100 setting into a 0..1 scale, defaulting to full when absent.
  const okAnnScale = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? Math.max(0, n) / 100 : 1;
  };

  const okAnnOrnaments = [];
  let okAnnLoopStarted = false;
  let okAnnLast = 0;

  const okAnnRender = (o) => {
    const level = OK_ANN_SEQUENCE[o.cursor];
    const t = level / 5;
    o.el.textContent = OK_ANN_GLYPHS[level];
    // Constant per-ornament vertical offset scatters them off the baseline.
    o.el.style.transform = `translateY(${o.offsetY.toFixed(3)}em) scale(${(0.7 + 0.3 * t).toFixed(3)})`;
    o.el.style.opacity = (0.45 + 0.55 * t).toFixed(3);
    // Halo grows with the bloom: none on `·`/`+`, strongest on `❋`.
    const glow = Math.max(0, (level - 1) / 4) * o.glowScale;
    o.el.style.textShadow = `0 0 ${(7 * glow).toFixed(2)}px color-mix(in oklab, currentColor ${Math.round(65 * glow)}%, transparent)`;
  };

  const okAnnTick = (now) => {
    const dt = okAnnLast ? now - okAnnLast : 16;
    okAnnLast = now;
    for (const o of okAnnOrnaments) {
      if (!o.el.isConnected) continue;
      o.acc += dt;
      if (o.acc >= o.stepMs) {
        o.acc -= o.stepMs;
        o.cursor = (o.cursor + 1) % OK_ANN_SEQUENCE.length;
        okAnnRender(o);
      }
    }
    requestAnimationFrame(okAnnTick);
  };

  const initAnnouncementTwinkle = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const slides = document.querySelectorAll('.announcement-bar__slide:not([data-twinkle-ready])');

    slides.forEach((slide) => {
      slide.setAttribute('data-twinkle-ready', '');

      // Per-slide settings (merchant-configurable in the theme editor).
      if (slide.dataset.ornamentAnimate === 'false') return;
      const [speedBase, speedSpread] = OK_ANN_SPEED[slide.dataset.ornamentSpeed] || OK_ANN_SPEED.medium;
      const glowScale = okAnnScale(slide.dataset.ornamentGlow);
      const scatterScale = okAnnScale(slide.dataset.ornamentScatter);

      const walker = document.createTreeWalker(slide, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          return node.parentElement.closest('.ok-sr-only') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
        },
      });

      const textNodes = [];
      let node;
      while ((node = walker.nextNode())) textNodes.push(node);

      textNodes.forEach((textNode) => {
        const value = textNode.nodeValue;
        if (!OK_ANN_ORNAMENTS.some((glyph) => value.includes(glyph))) return;

        const fragment = document.createDocumentFragment();
        for (const char of value) {
          if (OK_ANN_ORNAMENTS.includes(char)) {
            const span = document.createElement('span');
            span.className = 'announcement-ornament';
            span.setAttribute('aria-hidden', 'true');
            span.textContent = char;
            fragment.appendChild(span);
          } else {
            fragment.appendChild(document.createTextNode(char));
          }
        }
        textNode.replaceWith(fragment);
      });

      slide.querySelectorAll('.announcement-ornament').forEach((span) => {
        // Lock width across the full glyph ramp so morphing never reflows text.
        let maxWidth = 0;
        OK_ANN_GLYPHS.forEach((glyph) => {
          span.textContent = glyph;
          maxWidth = Math.max(maxWidth, span.getBoundingClientRect().width);
        });
        span.style.width = `${Math.ceil(maxWidth)}px`;

        const ornament = {
          el: span,
          cursor: Math.floor(Math.random() * OK_ANN_SEQUENCE.length),
          stepMs: speedBase + Math.random() * speedSpread,
          acc: 0,
          offsetY: (Math.random() * -0.45 + 0.12) * scatterScale, // em, biased up
          glowScale: glowScale,
        };
        okAnnRender(ornament);
        okAnnOrnaments.push(ornament);
      });
    });

    if (okAnnOrnaments.length && !okAnnLoopStarted) {
      okAnnLoopStarted = true;
      requestAnimationFrame(okAnnTick);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementTwinkle);
  } else {
    initAnnouncementTwinkle();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["value-prop"] && !Shopify.designMode) return;
  try {
    (function () {
    var cards = document.querySelectorAll('.page-about__prop-card:not([data-prop-init])');
    if (!cards.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var card = entry.target;
          var index = parseInt(card.dataset.propIndex || '0', 10);
          setTimeout(function () {
            card.classList.add('is-visible');
          }, index * 120);
          observer.unobserve(card);
        });
      },
      { threshold: 0.15 }
    );

    cards.forEach(function (card, i) {
      card.dataset.propInit = '1';
      card.dataset.propIndex = i;
      observer.observe(card);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
